// extracted by mini-css-extract-plugin
module.exports = {"root":"PersonWithPosition_root__1Rc3w","speciality":"PersonWithPosition_speciality__2J-f8"};